module.exports = __webpack_public_path__ + "img/del_country.b220a595.png";